import { render, staticRenderFns } from "./New_Materials_and_Finishes.vue?vue&type=template&id=304f5506&scoped=true"
import script from "./New_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
export * from "./New_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./New_Materials_and_Finishes.vue?vue&type=style&index=0&id=304f5506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f5506",
  null
  
)

export default component.exports